export const PaymentMethodComponent = {
    template: `
        <form ng-if="$ctrl.paymentData.cardPayment && $ctrl.paymentData.cashPayment">
            <div class="radio-bar payment-method">
                <input id="payment-method-credit" name="type" type="radio" ng-change="$ctrl.onChange()" ng-model="$ctrl.paymentMethod" ng-value="$ctrl.paymentData.cardPayment.method"></input>
                <label id="payment-method-credit-label" for="payment-method-credit">{{$ctrl.paymentService.data.cardPayment.displayName}}</label>
                <input id="payment-method-cash" name="type" type="radio" ng-change="$ctrl.onChange()" ng-model="$ctrl.paymentMethod" ng-value="$ctrl.paymentData.cashPayment.method"></input>
                <label id="payment-method-cash-label" for="payment-method-cash">{{$ctrl.paymentService.data.cashPayment.displayName}}</label>
            </div>
        </form>
    `,
    controller: class {
        constructor(checkoutService, paymentService) {
            'ngInject';
            this.checkoutService = checkoutService;
            this.paymentService = paymentService;
        }

        $onInit() {
            this.paymentService.initialize();
            this.paymentData = this.paymentService.data;
            this.paymentMethod = this.paymentData.selectedPayment.method;
        }

        onChange() {
            this.paymentService.setPaymentMethod(this.paymentMethod);
        }
    }
};
